// Import GSAP
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin); 


/**
 * Functionality to handle front page animation (full page effect)
 */
class TextAnimation {
	constructor(element) {
		// Find all necessary elements
		this.text = element;

		// Init functionalities if all elements has been found
		if (this.text) {
			this.init(this.text);
		}
		else {
			console.error("missing elements to properly init TextAnimation")
		}
	}

      /**
      * Init all default functionalities
      */
      init(text) {

            this.animation(text);


      }

      /**
      * Parallax effect for background image
      */
       animation(text) {
            ScrollTrigger.matchMedia({
                  "(min-width: 768px)": function() {
                        text.style.transform = text.getAttribute('data-transform-start');
                        // console.log(text.getAttribute('data-transform-start'))
                  
                        gsap.to(text, {
                        transform: text.getAttribute('data-transform-end'),
                        scrollTrigger: {
                              trigger: text.closest(`[data-item="animation-wrapper"]`),
                              start: "top bottom",
                              end: "bottom top",
                              scrub: 1,
                        }
                        });
                  } 
            });
      }

}

 window.addEventListener('load', () => {
      // Get all tabs list that need to use this functionality
      const allText = document.querySelectorAll(`[data-item="animate-text"]`);
      if (allText.length > 0) {
            allText.forEach(text => {
                  new TextAnimation(text);
          })
      }
  })
